// this value should match the version in package.json
export const HubSdkVersion: string = '0.2.2';

export const SdkMessageTypes = {
  appInitialization: {
    appLoaded: 'appInitialization.appLoaded',
    failure: 'appInitialization.failure',
    success: 'appInitialization.success',
  },
  appInstallDialog: {
    openAppInstallDialog: 'appInstallDialog.openAppInstallDialog',
  },
  authentication: {
    getAuthToken: 'authentication.getAuthToken',
    getUser: 'authentication.getUser',
    authenticate: 'authentication.authenticate',
    notifySuccess: 'authentication.authenticate.success',
    notifyFailure: 'authentication.authenticate.failure',
  },
  appEntity: {
    selectAppEntity: 'appEntity.selectAppEntity',
  },
  calendar: {
    composeMeeting: 'calendar.composeMeeting',
    openCalendarItem: 'calendar.openCalendarItem',
  },
  call: {
    startCall: 'call.startCall',
  },
  chat: {
    openConversation: 'conversations.openConversation',
    closeConversation: 'conversations.closeConversation',
    getChatMembers: 'getChatMembers',
  },
  deepLinks: {
    executeDeepLink: 'executeDeepLink',
    shareDeepLink: 'shareDeepLink',
  },
  dialogs: {
    open: 'tasks.startTask',
    resize: 'tasks.updateTask',
    submit: 'tasks.completeTask',
  },
  files: {
    openFilePreview: 'openFilePreview',
    getCloudStorageFolders: 'files.getCloudStorageFolders',
    addCloudStorageFolder: 'files.addCloudStorageFolder',
    deleteCloudStorageFolder: 'files.deleteCloudStorageFolder',
  },
  getContext: 'getContext',
  initialize: 'initialize',
  location: {
    getLocation: 'location.getLocation',
    showLocation: 'location.showLocation',
  },
  log: {
    handleAppLog: 'log.receive',
  },
  mail: {
    composeMail: 'mail.composeMail',
    openMailItem: 'mail.openMailItem',
  },
  media: {
    captureImage: 'captureImage',
    getMedia: 'getMedia',
    scanBarCode: 'media.scanBarCode',
    selectMedia: 'selectMedia',
    viewImages: 'viewImages',
  },
  meeting: {
    getAuthenticationTokenForAnonymousUser: 'meeting.getAuthenticationTokenForAnonymousUser',
    getIncomingClientAudioState: 'getIncomingClientAudioState',
    getMeetingDetails: 'meeting.getMeetingDetails',
    toggleIncomingClientAudio: 'toggleIncomingClientAudio',
  },
  notifications: {
    showNotification: 'notifications.showNotification',
  },
  pages: {
    returnFocus: 'returnFocus',
    navigateCrossDomain: 'navigateCrossDomain',
    setCurrentFrame: 'setFrameContext',
    backStack: {
      navigateBack: 'navigateBack',
    },
    tabs: {
      getTabInstances: 'getTabInstances',
      getMruTabInstances: 'getMruTabInstances',
      navigateToTab: 'navigateToTab',
    },
    config: {
      setConfig: 'settings.setSettings',
      getConfig: 'settings.getSettings',
      setValidityState: 'settings.setValidityState',
      save: {
        success: 'settings.save.success',
        failure: 'settings.save.failure',
      },
      remove: {
        success: 'settings.remove.success',
        failure: 'settings.remove.failure',
      },
    },
    fullTrust: {
      enterFullscreen: 'enterFullscreen',
      exitFullscreen: 'exitFullscreen',
    },
  },
  people: {
    selectPeople: 'people.selectPeople',
  },
  registerHandler: 'registerHandler',
  teams: {
    fullTrust: {
      getUserJoinedTeams: 'getUserJoinedTeams',
      getConfigSetting: 'getConfigSetting',
    },
  },
};

export enum FailedReason {
  AuthFailed = 'AuthFailed',
  Timeout = 'Timeout',
  Other = 'Other',
}

export const appUrlResource = {
  resourceDomainParameter: '{resourceDomain}',
  validResourcePattern: '^((https|api)://{resourceDomain}([:/].*)?)$',
};

export const fullPermissionApps: string[] = ['com.example.microsoftteamstabs.test', 'com.example.metaostestapp.test'];

export const AllowedRuntimeAppContexts: string[] = [
  'sessionId',
  'siteDomain',
  'tid',
  'userObjectId',
  'userPrincipalName',
  'locale',
  'entityId',
  'subEntityId',
  'hubName',
  'teamSiteDomain',
  'teamSitePath',

  // new Context
  'sharePointSite.domain',
  'sharePointSite.path',
  'app.sessionId',
];
